import { AlertLineReportNoteDTO } from "src/models/alert-line-report-note/alert-line-report-note-dto";
import { AlertLineReportNoteSTO } from "src/models/alert-line-report-note/alert-line-report-note-sto";
import { BaseApiService } from "../base";

export class AlertLineReportNoteApiService extends BaseApiService<AlertLineReportNoteDTO, AlertLineReportNoteSTO> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineReportNotes",
      saveItemsPath: "/SaveAlertLineReportNotes",
    });
  }
}
